import OpeningHours from '../../modules/store/openinghours.entity'

const DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

const parseTimeString = (time: string, options?: { closing: boolean }) => {
  const split = time.split(/(am|pm)/)
  const hoursAndMinutes = split[0]
  let ampm = 'am'

  if (split[1] && split[1] === 'pm') {
    ampm = 'pm'
  }

  /* Now parse hours and minutes */
  let hours = null
  let minutes = 0

  if (hoursAndMinutes.includes(':')) {
    hours = parseInt(hoursAndMinutes.split(':')[0])
    minutes = parseInt(hoursAndMinutes.split(':')[1])
  } else {
    hours = parseInt(hoursAndMinutes)
  }

  if (ampm === 'pm' && hours != 12) {
    hours = hours + 12
  }

  if (ampm === 'am' && hours === 12) {
    hours = 0
  }

  if (options?.closing && ampm === 'am' && hours < 6) {
    hours = hours + 24
  }

  return { hours, minutes }
}

const getTodayString = () => {
  return DAYS[new Date().getDay()]
}

const getStoreOpenCloseStatus = (hours: OpeningHours) => {
  if (!hours) {
    return 'Contact store for opening hours'
  }

  const todaysHours = hours[getTodayString()]

  if (!todaysHours) {
    return 'Closed today'
  }

  if (!todaysHours[0] || !todaysHours[1]) {
    return 'Closed today'
  }

  const currentTime = new Date()
  const currentMinutes = currentTime.getHours() * 60 + currentTime.getMinutes()
  const parsedOpening = parseTimeString(todaysHours[0])
  const parsedClosing = parseTimeString(todaysHours[1], { closing: true })
  const openTimeMinutes = parsedOpening.hours * 60 + parsedOpening.minutes
  const closeTimeMinutes = parsedClosing.hours * 60 + parsedClosing.minutes
  let isCurrentlyOpen = currentMinutes >= openTimeMinutes && currentMinutes < closeTimeMinutes

  if (!isCurrentlyOpen && currentMinutes < openTimeMinutes) {
    return `Opens ${todaysHours[0]}`
  }

  return isCurrentlyOpen ? `Open - Closes ${todaysHours[1]}` : 'Currently closed'
}

const isStoreCurrentlyOpen = (hours: OpeningHours) => {
  if (!hours) {
    return false
  }

  const todaysHours = hours[getTodayString()]

  if (!todaysHours) {
    return false
  }

  const currentTime = new Date()
  const currentMinutes = currentTime.getHours() * 60 + currentTime.getMinutes()
  const parsedOpening = parseTimeString(todaysHours[0])
  const parsedClosing = parseTimeString(todaysHours[1], { closing: true })
  const openTimeMinutes = parsedOpening.hours * 60 + parsedOpening.minutes
  const closeTimeMinutes = parsedClosing.hours * 60 + parsedClosing.minutes
  let isCurrentlyOpen = currentMinutes >= openTimeMinutes && currentMinutes < closeTimeMinutes

  return isCurrentlyOpen
}

const getStoreClosingTime = (hours: OpeningHours) => {
  if (!hours) {
    return false
  }

  const todaysHours = hours[getTodayString()]

  if (!todaysHours) {
    return false
  }

  const parsedClosing = parseTimeString(todaysHours[1], { closing: true })
  const closeTime = new Date()
  closeTime.setHours(parsedClosing.hours)
  closeTime.setMinutes(parsedClosing.minutes)
  return closeTime
}

export {
  parseTimeString,
  getTodayString,
  getStoreOpenCloseStatus,
  isStoreCurrentlyOpen,
  getStoreClosingTime,
}
